module.exports = __webpack_public_path__ + "img/AK0090-BL.443baa57.jpg";